import { useContext } from 'react';
import { ResourceContext } from '../Resource';

export const useResource = (props) => {
  const { resources } = useContext(ResourceContext);
  const { resourceName } = props;
  return resources.find(({ name }) => name === resourceName);
};
